import { Body, Box, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import HowDoesItWorkQuickerJobVector from '../assets/svgs/HowDoesItWorkQuickerJobVector';
import { IHowHoverWorksCaseStudy } from '../interfaces/IHowHoverWorksCaseStudy';
import { IHowHoverWorksTab } from '../interfaces/IHowHoverWorksTab';
import { IProjectVision } from '../interfaces/IProjectVision';

export const HOW_HOVER_WORKS_CASE_STUDIES_DATA: IHowHoverWorksCaseStudy[] = [
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="moral family"
        src="../assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 0,
  },
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="moral family"
        src="../assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 1,
  },
  {
    header: 'The Morales Family used HOVER to replace their aging roof.',
    body: 'Social proofing via testimonials by audience type. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula.',
    name: 'morales family',
    address: 'los angeles, CA / Roof remodelling',
    image: (
      <StaticImage
        placeholder="blurred"
        alt="moral family"
        src="../assets/images/how_hover_works_case_study_1.png"
      />
    ),
    id: 2,
  },
];

export const HOW_HOVER_WORKS_LIST_DATA: IHowHoverWorksTab[] = [
  {
    title: 'TAKE SOME PHOTOS',
    body: 'With just a few photos, HOVER can create an accurately measured 3D model of a home.',
    id: 0,
    desktopImage: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="take photo 1"
        src="../assets/images/how_does_hover_work_take_photo_1.png"
        objectFit="contain"
      />
    ),
    mobileImage: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="take photo 1"
        src="../assets/images/how_does_hover_work_take_photo_1_mobile.png"
        objectFit="contain"
      />
    ),
  },
  {
    title: 'BETTER MEASUREMENTS',
    body: 'Your pro gets a detailed report of accurate measurements of your home from those photos.',
    id: 1,
    desktopImage: (
      <StaticImage
        objectFit="contain"
        loading="lazy"
        placeholder="blurred"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        loading="lazy"
        placeholder="blurred"
        alt="better measurements 1"
        src="../assets/images/how_does_hover_work_better_measurement.png"
      />
    ),
  },
  {
    title: 'DREAM AND DESIGN',
    body: 'You get a 3D model of your home to design; with your pro, select materials for your project',
    id: 2,
    desktopImage: (
      <StaticImage
        loading="lazy"
        objectFit="contain"
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_dream_design_1.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        loading="lazy"
        placeholder="blurred"
        alt="dream and design"
        src="../assets/images/how_does_hover_work_dream_design_1_mobile.png"
      />
    ),
  },
  {
    title: 'FAIR ESTIMATION',
    body: 'Your pro uses your design choices and measurements to quickly and accurately estimate your project.',
    id: 3,
    desktopImage: (
      <StaticImage
        loading="lazy"
        objectFit="contain"
        placeholder="blurred"
        alt="take photo"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
    mobileImage: (
      <StaticImage
        objectFit="contain"
        loading="lazy"
        placeholder="blurred"
        alt="take photo"
        src="../assets/images/how_does_hover_work_fair_estimation.png"
      />
    ),
  },
];

export const PROJECT_VISIONS: IProjectVision[] = [
  {
    title: 'designing',
    header: 'Design in 3D on your actual (ok, virtual) home',
    body: 'Super fun part: Use the design tools in our app to change colors, roof style, siding type, windows and more with real products on your home’s 3D model. Pretty cool, huh?',
    secondBody:
      'Collaborate with your contractor on design decisions, material selections, and other project plans.',
    id: 0,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/how_does_it_work_designing.png"
        width={378}
        height={560}
      />
    ),
  },
  {
    title: 'estimating',
    header: 'More accurate estimates made simple',
    body: 'Accurate measurements result in the most accurate estimates and fewer unexpected costs later.',
    secondBody:
      'HOVER helps contractors and insurers estimate project and repair costs with confidence for the fairest deal in the shortest amount of time.',
    id: 1,
    image: (
      <StaticImage
        loading="lazy"
        placeholder="blurred"
        alt="faster measurements"
        src="../assets/images/how_does_it_work_estimation.png"
        width={480}
        height={480}
      />
    ),
  },
  {
    title: 'project management',
    header: 'Quicker job completions',
    body: 'Your project gets done more quickly with HOVER’s fast measurements, estimating, and ordering.',
    secondBody:
      'HOVER simplifies getting the job done, so you can get to your “better” fast and with less stress.',
    id: 2,
    image: (
      <Box position="relative">
        <Box w={{ base: '100%', tablet: 'auto' }} px={200}>
          <HowDoesItWorkQuickerJobVector width="100%" />
        </Box>
        <Box
          flexDir="column"
          alignItems="center"
          position="absolute"
          top="150px"
          left="50%"
          translateX="-50%"
          transform="auto"
          maxW="280px"
        >
          <Body
            textAlign="center"
            letterSpacing="1px"
            size={300}
            isBold
            color="neutral.0"
            mb={200}
          >
            3D MODELS AND MEASUREMENTS RETURNED IN UNDER 24 HOURS:
          </Body>
          <Heading
            as="p"
            size={{ base: 600, tablet: 700, desktop: 800 }}
            isDisplay
            color={{ base: 'neutral.0', desktop: 'neutral.0' }}
          >
            99.4%
          </Heading>
        </Box>
      </Box>
    ),
  },
];
